// extracted by mini-css-extract-plugin
export var actionButton = "_ih-t";
export var buttonContainer = "_ih-0";
export var buttonContainer2 = "_ih-1";
export var buttonSection = "_ih-2";
export var details = "_ih-3";
export var dropdownItem = "_ih-5";
export var dropdownItemsContainer = "_ih-4";
export var fileInput = "_ih-r";
export var headerButton = "_ih-6";
export var icon = "_ih-7";
export var input = "_ih-8";
export var macroListItem = "_ih-9";
export var mainContent = "_ih-a";
export var microText = "_ih-b";
export var modal = "_ih-w";
export var optionsButton = "_ih-c";
export var paperclip = "_ih-s";
export var pillContent = "_ih-d";
export var preview = "_ih-e";
export var preview2 = "_ih-f";
export var quillEditor = "_ih-q";
export var selectedMacro = "_ih-g";
export var sidebar = "_ih-h";
export var sidebarHeader = "_ih-j";
export var sidebarList = "_ih-i";
export var sidebarListItem = "_ih-k";
export var sidebarSearch = "_ih-l";
export var snoozeDurationWrapper = "_ih-v";
export var statusPillContainer = "_ih-m";
export var tagsContainer = "_ih-n";
export var unselectedMacro = "_ih-o";
export var variable = "_ih-u";
export var wrapper = "_ih-p";